import { useAppSelector } from '@/shared/lib/redux';

/**
 * Хук доступа к текущему администратору
 */
export const useAdminUser = () => {
  return useAppSelector(state => state.adminSession.data);
};
